import { Activity, DollarSign, LayoutDashboard, Target, Users } from 'lucide-react'
import type { RolePermissions } from '@/components/Dashboard/RoleGuard'

const TAB_ALIASES: Record<string, string> = {
  summary: 'operacao',
  sales: 'pipeline',
  bdr: 'captacao',
  admin: 'time',
  commissions: 'comissoes',
  retention: 'operacao',
  ops: 'operacao',
}

export function buildDashboardTabs(permissions: RolePermissions) {
  const tabs = [
    { id: 'operacao', label: 'Operação', icon: <LayoutDashboard size={14} /> },
    { id: 'pipeline', label: 'Pipeline', icon: <Target size={14} /> },
  ]

  if (permissions.canSeeBdrPanel) {
    tabs.push({ id: 'captacao', label: 'Captação', icon: <Users size={14} /> })
  }

  if (permissions.canSeeCommissions) {
    tabs.push(
      { id: 'time', label: 'Time', icon: <Activity size={14} /> },
      { id: 'comissoes', label: 'Comissões', icon: <DollarSign size={14} /> },
    )
  }

  return tabs
}

export function resolveDashboardTab(defaultTab: string, tabIds: string[]): string {
  const mapped = TAB_ALIASES[defaultTab] ?? defaultTab
  if (tabIds.includes(mapped)) return mapped
  return tabIds[0] ?? 'operacao'
}
